import React, { useEffect, useState } from "react";
import { Dropdown } from "react-bootstrap";
import { Company, Vendor } from "../../atomic_components/types";

interface CompanyNamesDropdownProps {
  options: Company[];
  onItemSelected: (value: Company) => void;
  providedSelectedValue: Company | undefined;
}

const CompanyPurchaseOrdersCompanyNamesDropdown: React.FC<
  CompanyNamesDropdownProps
> = ({ options, onItemSelected, providedSelectedValue }) => {
  const [filter, setFilter] = useState<string>("");
  const [selectedValue, setSelectedValue] = useState<Company | undefined>(
    providedSelectedValue
  );

  useEffect(() => {
    setSelectedValue(providedSelectedValue);
  }, [providedSelectedValue]);

  const filteredOptions = options.filter((option) =>
    option.company_name.toLowerCase().includes(filter.toLowerCase())
  );

  const handleSelect = (value: string | null) => {
    console.log("logging selected option ", value);
    if (value) {
      options.forEach((option) => {
        if (option.company_id.toString() === value) {
          setSelectedValue(option);
          onItemSelected(option);
        }
      });
    }
  };

  return (
    <Dropdown onSelect={handleSelect}>
      <Dropdown.Toggle
        variant="primary"
        id="dropdown-basic"
        style={{ width: "100%", fontSize: "14px" }}
      >
        {(selectedValue &&
          `${selectedValue.company_name} [${selectedValue.company_id}]`) ||
          "Select Company"}
      </Dropdown.Toggle>

      <Dropdown.Menu
        style={{ width: "100%", maxHeight: "200px", overflowY: "auto" }}
      >
        <input
          type="text"
          className="form-control mb-2"
          placeholder="Filter options..."
          value={filter}
          style={{ width: "100%" }}
          onChange={(e: React.ChangeEvent<HTMLInputElement>) =>
            setFilter(e.target.value)
          }
        />
        {filteredOptions.map((option, index) => (
          <Dropdown.Item
            key={option.company_id}
            eventKey={option.company_id as any}
          >
            {option.company_name} [{option.company_id}]
          </Dropdown.Item>
        ))}
      </Dropdown.Menu>
    </Dropdown>
  );
};

export default CompanyPurchaseOrdersCompanyNamesDropdown;
